var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilWriting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_8048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75114 21.0068C3.55558 21.3328 2.06225 28.2957 2.06225 28.2957C2.00399 28.5622 2.00599 28.8383 2.0681 29.1039C2.1302 29.3694 2.25086 29.6178 2.42124 29.8308C2.59162 30.0437 1.80743 29.216 2.0529 29.3349C2.29836 29.4538 2.56729 29.5163 2.84003 29.518C2.96711 29.5308 3.09517 29.5308 3.22225 29.518C3.22225 29.518 10.1111 28.2734 10.5556 27.8291C11 27.3847 24.6356 13.8024 24.6356 13.8024L17.7778 6.9624C17.7778 6.9624 3.9467 20.6809 3.75114 21.0068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0622 6.78008L24.8178 2.53563C24.473 2.19258 24.0064 2 23.52 2C23.0336 2 22.567 2.19258 22.2222 2.53563L19.3066 5.45119L26.1555 12.3001L27.6133 10.8423L29.0711 9.38452C29.2417 9.21304 29.3768 9.00959 29.4687 8.78582C29.5607 8.56206 29.6075 8.32236 29.6067 8.08046C29.6059 7.83855 29.5574 7.59918 29.4639 7.37605C29.3705 7.15291 29.234 6.95039 29.0622 6.78008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29.75C29.9142 29.75 30.25 29.4142 30.25 29C30.25 28.5858 29.9142 28.25 29.5 28.25V29.75ZM2.5 29.75H29.5V28.25H2.5V29.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_8048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWriting);
export default __webpack_public_path__ + "static/media/pencil_writing.04fa03fd9ab454f9ebf36a8f85310e86.svg";
export { ForwardRef as ReactComponent };